import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
import { textStyles } from "../Text";
import { StyledButton, defaultButtonPadding } from "../Button/Button";
export function InputAdornment(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  var renderChildren = function renderChildren() {
    return children;

    if (typeof children === 'string') {
      return children;
    }

    var child = React.Children.only(children);
    return React.cloneElement(child, {
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      }
    });
  };

  return /*#__PURE__*/React.createElement(StyledInputAdornment, other, renderChildren());
}
var StyledInputAdornment = styled.div.withConfig({
  displayName: "InputAdornment__StyledInputAdornment",
  componentId: "vapor__sc-14by5ae-0"
})(["", ";display:flex;align-items:center;justify-content:center;color:currentColor;margin:", ";", "{border-radius:", ";padding:", ";", " margin:", ";}}"], textStyles.primary, function (p) {
  return p.$placement === 'start' ? "0 -".concat(theme.spaces[4], " 0 ").concat(theme.spaces[8]) : "0 ".concat(theme.spaces[8], " 0 0");
}, StyledButton, theme.radii[4], defaultButtonPadding, function (p) {
  return p.$placement === 'start' ? "\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    " : "\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    ";
}, function (p) {
  return p.$placement === 'start' ? "0 0 0 -".concat(theme.spaces[8]) : "0 -".concat(theme.spaces[8], " 0 0");
});